// extracted by mini-css-extract-plugin
export default {"tabs":"Qk9erJwz","tab":"YqZ0UOKw","active":"GEukv5zH"};
    if(module.hot) {
      // 1738090063631
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  